<script>
	import { prefix, intakeTimes, mainStep, delayShort, delayMedium, startTime, i18n, language, stepQuestion, questions } from '../stores.js';
    import Icon from '../Atoms/Icon.svelte';
    import { onDestroy } from 'svelte';
	import { fade, scale, slide, fly } from 'svelte/transition';
	import { quartIn, quintIn } from 'svelte/easing';
    import { tick } from 'svelte';
    
	export let packType = 'morning';

</script>

<div class="{$prefix}-medpack">
    <span class="{$prefix}-medpack__time">{$intakeTimes.times[packType]}</span>
    <span class="{$prefix}-medpack__icons">
        <Icon iconName="drugbox" iconClass="" />
        <Icon iconName="{packType}" iconClass="" />
    </span>
    <span class="{$prefix}-medpack__schedule">{$intakeTimes.schedules[packType]}</span>

</div>

<style type="text/scss">
    @import './sass/vars';

    .#{$prefix}-medpack { 
        display: flex;
        flex-flow: column nowrap;
        justify-content: space-evenly;
        border: solid 0.25rem #cdefee;
        box-shadow: $drop-shadow-box;
        width: 11rem;
        height: 12rem;
        margin-right: 1.25rem;
        margin-bottom: 2rem;
        border-bottom-right-radius: 4rem;
        border-top-left-radius: 3rem;
        padding: 1rem;

        &__time {
            text-align: right;
        }

        &__schedule {
            font-weight: bold;
            color: $secondary;
        }
    }

</style>